<template>
  <v-col id="formGroup">
    <v-container grid-list-xs>
      <v-row>
        <v-col
          v-if="title"
          cols="2"
        >
          <span class="h2Header secondary300">{{ title }}</span>
          <slot name="title" />
        </v-col>
        <v-col :cols="getCols">
          <v-container
            class="pa-0"
          >
            <slot />
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>

export default {
  name: 'FormGroup',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    getCols() {
      return this.title ? '10' : '12';
    },
  },
};
</script>

<style scoped>
#formGroup {
  padding-top: 2rem;
  padding-bottom: 1rem;
}
</style>
